export const API_KEY = 'AIzaSyBuF4bsmiA1e_OEG8bo6_oISnAR8LXbQDk';
export const CONTEXT_KEY = '9315428aefc796032';
// export default API_KEY;
